import { isEqual, keys } from 'lodash-es';
import { DateRange, SearchFilterType } from './types';
export const makeInitialFilterValue = (filterConfig)=>{
    switch(filterConfig.type){
        case SearchFilterType.MultiSelectFilter:
            return [];
        case SearchFilterType.DateRangeFilter:
            return {
                from: undefined,
                to: undefined
            };
        case SearchFilterType.RadioFilter:
            return filterConfig.defaultOption;
        case SearchFilterType.DateRangeWithPresets:
            return {
                dateRangeOption: DateRange.AllTime,
                dateRange: []
            };
        case SearchFilterType.CustomFilter:
            return filterConfig.initialValue;
    }
};
export const isInitialFilterValue = (filterValue, filterConfig)=>isEqual(filterValue, makeInitialFilterValue(filterConfig));
// Assumes a filter's initialValue/defaultOption represents "no filter applied".
// If a filter's initial value is meaningful (i.e., actively filtering), provide
// config.mobile.isEmptyValue to override this behavior.
export const isEmptyFilterValue = (value, config)=>{
    var _config_mobile;
    if (value === undefined || value === null) return true;
    if ((_config_mobile = config.mobile) === null || _config_mobile === void 0 ? void 0 : _config_mobile.isEmptyValue) {
        return config.mobile.isEmptyValue(value);
    }
    if (Array.isArray(value) && value.length === 0) return true;
    if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) return true;
    return isInitialFilterValue(value, config);
};
export const filterEmptyValues = (selectedFilters, filterConfig)=>{
    const result = {};
    for (const key of keys(selectedFilters)){
        if (!isEmptyFilterValue(selectedFilters[key], filterConfig[key])) {
            result[key] = selectedFilters[key];
        }
    }
    return result;
};
